export default {
  //预加载
  loading(obj) {
    setTimeout(function () {
      obj.loadingShow = false
    }, 1500)
  },
  //默认图设置
  pic(obj) {
    obj.defaultImg = 'this.src="' + require('../../assets/img/head.png') + '"'; //默认头像
    obj.defaultIco = 'this.src="' + require('../../assets/img/ico.png') + '"'; //默认图标
    obj.defaultLogo = 'this.src="' + require('../../assets/img/logo.png') + '"'; //默认logo
    obj.defaultPic = 'this.src="' + require('../../assets/img/default.png') + '"'; //默认logo
  },
  //截取日期
  getPartTime(val) {
    var timearr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
    var timestr = timearr[0] + "." + timearr[1] + "." + timearr[2];
    return timestr;
  },
  //截取日期
  getDate(val) {
    var timearr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
    var timestr = timearr[0] + "." + timearr[1] + "." + timearr[2] + " " + timearr[3] + ":" + timearr[4] + ":" +
      timearr[5];
    return timestr;
  },

  // 倒计时

  countTime(timeStamp) {
    var day;
    var hour;
    var min;
    var seconds;

    day = parseInt(timeStamp / (24 * 60 * 60)) // 计算整数天数
    var afterDay = timeStamp - day * 24 * 60 * 60 // 取得算出天数后剩余的秒数
    hour = parseInt(afterDay / (60 * 60)) // 计算整数小时数
    var afterHour = timeStamp - day * 24 * 60 * 60 - hour * 60 * 60 // 取得算出小时数后剩余的秒数
    min = parseInt(afterHour / 60) // 计算整数分
    seconds = parseInt(timeStamp - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60) // 取得算出分后剩余的秒数

    if (day < 10) {
      day = '0' + day;
    }

    if (hour < 10) {
      hour = '0' + hour
    }
    ;

    if (min < 10) {
      min = '0' + min;
    }

    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    const restStamp = {
      day: day,
      hour: hour,
      min: min,
      seconds: seconds
    }
    return restStamp
  },
  // 获得距离活动开始还剩余的时间
  mistiming(s, e, obj) {
    var nowtime = Date.parse(new Date()) / 1000;
    var time = '';
    if (nowtime > s) {
      time = nowtime;
      var timeStamp = e - time;
      obj.times = this.countTime(timeStamp);
      const str = `${obj.times.day}天${obj.times.hour}时${obj.times.min}分${obj.times.seconds}秒`
      obj.countTxt = str;
      var TimeDown = setInterval(() => {
        if (timeStamp > 0) {
          timeStamp--;
          const newTime = this.countTime(timeStamp);
          const str = `${newTime.day}天${newTime.hour}时${newTime.min}分${newTime.seconds}秒`
          obj.countDown = "距离活动结束";
          obj.countTxt = str;
        } else {
          obj.countDown = "";
          obj.countTxt = '活动已结束'
          clearInterval(TimeDown);
        }
      }, 1000)
    } else {
      let endtime = s - nowtime;
      obj.times = this.countTime(endtime);
      const strs = `${obj.times.day}天${obj.times.hour}时${obj.times.min}分${obj.times.seconds}秒`
      obj.countTxt = strs;
      var TimeOut = setInterval(() => {
        if (endtime > 0) {
          endtime--;
          const newTime = this.countTime(endtime);
          const str = `${newTime.day}天${newTime.hour}时${newTime.min}分${newTime.seconds}秒`
          obj.countDown = "距离活动开始";
          obj.countTxt = str;
        } else {
          // obj.countDown="";
          // obj.countTxt = '活动已结束'
          clearInterval(TimeOut);
        }
      }, 1000)
    }

  },

  //获取链接上参数
  getParam(variable) {
    var query = window.location.search.substring(1);
    var query3 = window.location.href.split("?");
    query = query + '&' + query3[2];
    console.log("param：" + query);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return (false);
  },


  //判断是否为空
  isnull(val) {
    if (val == "" || val == null || val == undefined || val == " ")
      return true;
    return false;
  },
  // 隐藏手机号
  mobileFilter(val) {
    let reg = /^(.{3}).*(.{4})$/
    return val.replace(reg, '$1****$2')
  },
  jsSDK(params) {
    if (typeof window.WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', function () {
          this.onBridgeReady(params)
        }, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', function () {
          this.onBridgeReady(params)
        })
        document.attachEvent('onWeixinJSBridgeReady', function () {
          this.onBridgeReady(params)
        })
      }
    } else {
      this.onBridgeReady(params)
    }
  },

  onBridgeReady(params) {
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
      'appId': params.appId, // 公众号名称，由商户传入
      'timeStamp': params.timeStamp, // 时间戳，自1970年以来的秒数
      'nonceStr': params.nonceStr, // 随机串
      'package': params.package,
      'signType': params.signType, // 微信签名方式：
      'paySign': params.paySign // 微信签名
    },
      function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          window.location.href = params.Url;
          location.reload();
        }
      }
    )
  },
  //音乐
  star(obj) {
    this.audioAutoPlay('bgMusic');
    document.addEventListener("visibilitychange", (e) => { // 兼容ios微信手Q
      if (document.visibilityState === 'visible') {
        if (obj.clickMusicBtn === true) { // 点击了关闭音乐按钮
          this.audioPause('bgMusic');
          obj.playFlag = false;
        } else { // 未点击关闭音乐按钮
          this.audioAutoPlay('bgMusic');
          obj.playFlag = true;
        }
      }
    });
  },
  audioPause(id) {
    var audio = document.getElementById(id);
    audio.pause();
    document.addEventListener("WeixinJSBridgeReady", function () {
      audio.pause();
    }, false);
    document.addEventListener('YixinJSBridgeReady', function () {
      audio.pause();
    }, false);
  },
  audioAutoPlay(id) {
    var audio = document.getElementById(id);
    audio.play();
    document.addEventListener("WeixinJSBridgeReady", function () {
      audio.play();
    }, false);
    document.addEventListener('YixinJSBridgeReady', function () {
      audio.play();
    }, false);
  },

  /**
   * 
   * @param {*} num 随机取多少个词语
   * @returns 
   */
  randomWords(num) {
    var mainTitle = ['一帆风顺', '温馨', '温暖', '感恩', '给力', '大吉', '大利', '大礼', '善美', '大爱', '比心', '豪爽', '吉利', '冲刺', '宠爱', '喜欢', '时尚', '等你',
      '发发', '如意', '称心', '大气', '好评', '美丽', '美好', '阳光', '快来', '快快快', '发发发', '顺达', '顺发', '大发', '冲冲冲', '快乐', '乐意', '乐享', '享受', '乐善', '加油', '便宜', '实惠'
      , '惠顾', '谢谢', '感谢', '如愿', '愿意', '向往', '优惠', '优享礼献', '礼物', '礼品', '奉献', '丰富', '丰收', '丰盈', '福气', '富贵', '富豪',
      '优秀', '优势', '势头强劲', '情意', '情怀', '惊喜', '喜庆', '庆贺', '贺喜', '好喜欢', '好的', '好多', '多多', '玫瑰', '牡丹', '芙蓉', '杜鹃', '康乃馨', '百合', '万福', '优品'];
    var n = 0
    var res = [];
    var resIndexs = [];
    if (num > mainTitle.length) {
      Toast("你取的词太多了。我只有" + mainTitle.length);
      return;
    }
    while (n < num) {
      var i = Math.floor(Math.random() * ((mainTitle.length - 1) - 0 + 1) + 0);
      var isHas = false;
      for (var j = 0; j < resIndexs.length; j++) {
        if (resIndexs[j] === i) {
          isHas = true;
          break;
        }
      }
      if (!isHas) {
        res.push(mainTitle[i]);
        resIndexs.push(i);
        n++;
      }
    }
    console.log('随机词：', res, resIndexs);
    return res;
  }

}



// WEBPACK FOOTER //
// ./src/pages/utils/public.js